import { render } from "./SelectorSearchHeader.vue?vue&type=template&id=012a6ff6&scoped=true&ts=true"
import script from "./SelectorSearchHeader.vue?vue&type=script&lang=ts"
export * from "./SelectorSearchHeader.vue?vue&type=script&lang=ts"

import "./SelectorSearchHeader.vue?vue&type=style&index=0&id=012a6ff6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012a6ff6"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QField});
